module.exports = __webpack_public_path__ + "img/bj10.6a0faaeb.png";